import { apiService } from './api';

export interface DashboardData {
  overview: {
    todayRevenue: number;
    todayOrders: number;
    activeOrders: number;
    availableTables: number;
    totalTables: number;
    availableItems: number;
    totalItems: number;
    outOfStockItems: number;
  };
  todaySummary: {
    totalOrders: number;
    grossAmount: number;
    discountGiven: number;
    netRevenue: number;
    taxAmount: number;
    avgOrderValue: number;
  };
  tableStatus: {
    available: number;
    occupied: number;
    reserved: number;
    outOfService: number;
  };
  salesTrend: {
    daily: Array<{
      date: string;
      revenue: number;
      orders: number;
      avgOrderValue: number;
    }>;
    comparison: {
      revenueGrowth: number;
      ordersGrowth: number;
      positive: boolean;
    };
  };
  topItems: Array<{
    itemId: string;
    itemName: string;
    category: string;
    quantitySold: number;
    revenue: number;
    percentage: number;
  }>;
  paymentMethods: Array<{
    method: string;
    amount: number;
    count: number;
    percentage: number;
  }>;
  categoryWiseSales: Array<{
    category: string;
    itemsSold: number;
    revenue: number;
    percentage: number;
  }>;
  recentOrders: Array<{
    orderId: string;
    orderNo?: string;
    orderNumber: string;
    customerName: string;
    tableNumber: string;
    items: number;
    amount: number;
    status: string;
    createdAt: string;
    timeElapsed: string;
  }>;
  outstandingDues: {
    totalAmount: number;
    count: number;
    dues: Array<{
      orderId: string;
      customerName: string;
      customerMobile: string;
      amount: number;
      orderDate: string;
      daysOverdue: number;
    }>;
  };
  hourlyPerformance: Array<{
    hour: string;
    orders: number;
    revenue: number;
    peakHour: boolean;
  }>;
  staffPerformance: Array<{
    userId: string;
    userName: string;
    ordersHandled: number;
    totalRevenue: number;
    avgOrderValue: number;
  }>;
  alerts: Array<{
    type: string;
    priority: string;
    message: string;
    timestamp: string;
  }>;
}

export const dashboardService = {
  async getDashboardData(organizationCode: string, restaurantId?: string | null): Promise<DashboardData> {
    const response = await apiService.get<DashboardData>('/reports/dashboard', {
      org: organizationCode,
      ...(restaurantId && { restaurantId })
    });
    return response.data;
  }
};
